import { useForm } from "react-hook-form";
import { RefreshCcw } from "lucide-react";
import { useParams } from "react-router-dom";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import MultipleChecks from "../form/addUser/MultipleChecks";
import UpdateAdminsRolesSuccessDialog from "../dialogs/UpdateAdminsRolesSuccessDialog";

const actionSetup = [
  { name: "Add Role", id: "add" },
  { name: "Remove Role", id: "remove" },
];

const UpdateRolesForm = ({ rolesSetup, sendData, isSucceed, loading }) => {
  const { id, name } = useParams();
  const {
    handleSubmit,
    watch,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      roles: [],
    },
  });

  const { roles, action } = watch();

  const onSubmit = (data) => {
    const confirmData = { id: parseInt(id), ...data };
    sendData(confirmData, reset);
  };

  return (
    <div className="form-container">
      <CenteredHeading title="Update Roles" />
      <div className="formDetails">
        <p>
          <strong>User Name</strong> : {name}
        </p>
        <p>
          <strong>User Id</strong> : {id}
        </p>
      </div>
      <form
        className="form-border max-w-3xl mx-auto"
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
      >
        <SearchDropdown
          name="action"
          label="Role Actions *"
          keyName="name"
          id="id"
          options={actionSetup}
          control={control}
          setValue={setValue}
          selectedVal={action}
          error={errors.action}
        />
        <MultipleChecks
          options={rolesSetup.roles}
          name="roles"
          control={control}
          error={errors.roles}
          roles={roles}
        />
        <div className="submitWrap">
          <p className="addWrap">
            <PrimaryButton
              btnText={!loading ? "Update Roles" : "Adding..."}
              loading={loading}
              Icon={RefreshCcw}
              size={18}
            />
          </p>
          <p className="grayWrap">
            <GrayButton btnText="Reset" width="w-40" onClick={() => reset()} />
          </p>
        </div>
      </form>
      {isSucceed && (
        <UpdateAdminsRolesSuccessDialog msg="User Role Successfully Updated" />
      )}
    </div>
  );
};
export default UpdateRolesForm;
